export default "__VITE_ASSET__CX$y02s3__"